<style lang="scss" scoped>
.settings {
    @include container();
    &__section {
        padding-bottom: 70px;
        border-bottom: 1px solid #eee;
        margin-bottom: 30px;
        &:last-child {
            margin-bottom: 0;
            border-bottom: 0;
        }
    }
    &__year {
        margin-left: 20px;
    }
    &__row {
        @include grid();
    }
    &__left {
        @include grid-col(4);
        padding-right: 40px;
    }
    &__right {
        @include grid-col(8);
    }
    &__pad-bottom {
        margin-bottom: 30px;
    }
    &__pad-right {
        padding: 20px;
    }
    &__border-bottom {
        border-bottom: 1px solid #eee;
    }
    & ::v-deep .el-cascader {
        width: 100%;
    }
    & ::v-deep .el-select {
        width: 100%;
    }
    .warning a {
        color: #eb4335 !important;
        font-weight: bold;
    }
    .preview {
        margin: 0;
    }

    .d-block {
        display:block;
        line-height:1;
        
    }
    .d-block ~ span, .warning-text {
            margin-bottom:50px;
            font-size:13px;
            color:red
        }

    &__supplementary-text {
        font-size: 12px;
        line-height: 1.3;
        padding-bottom: 10px;
    }

    &__switch-text {
        margin-left: 20px;
        width: 25%;
    }

    .dashboardTiles {
        display:flex;
        flex-wrap: wrap;
        & div {
            & .dashboardTiles-item {
                min-width: 160px;
                margin: 10px 10px 0 0;
            }
        }
    }

}

</style>
<template lang="pug">
.settings
    .main-panel
        loading(v-if="!form && $apollo.loading")
        template(v-if="form")
            .main-panel__padding.settings__section
                el-form(label-position="top")
                    .settings__row
                            .settings__left
                                h2.mt-3 Rolling calendar sync 
                                p Manage syncing rolling calendars.
                            .settings__right
                                el-card.box-card.settings__pad-bottom
                                    el-form-item
                                        el-switch(v-model="form.rolling_calendar_enabled")
                                        span.settings__switch-text Enable rolling calendar sync
                                    el-form-item(v-if="form.rolling_calendar_enabled", label="Select day when the rolling calendar will be synced")
                                        el-select(v-model="form.rolling_calendar_sync_day")
                                            el-option(v-for="(item,i) in weekdays" :key="i" :label="item" :value="i" )
                    .settings__row
                        .settings__left
                            h2.mt-3 Sync student calendars 
                            p Manage syncing student timetables into calendars.
                        .settings__right
                            student-rules.box-card.settings__pad-bottom(v-model="student_calendar_rule_object", :rules_type="`calendar`")
                    .settings__row
                        .settings__left
                            h2.mt-3 Student lesson sync
                        .settings__right
                            el-card.box-card.settings__pad-bottom
                                el-form-item(label="Maximum number of weeks to sync")
                                    el-select(v-model="form.calendar_lesson_weeks_student")
                                        el-option(v-for="(item,i) in [0,1,2,3,4]" :key="i" :label="item" :value="item" )
                                el-form-item
                                    custom-field-format(
                                        v-model="form.calendar_lesson_title_student",
                                        fieldLabel="Event title",
                                        :fieldNames="{...fieldNames.lessonTitles}",
                                        settingKey="calendar_lesson_title_student"
                                    )
                                el-form-item
                                    custom-field-format(
                                        v-model="form.calendar_lesson_description_student",
                                        fieldLabel="Event description",
                                        :fieldNames="{...fieldNames.lessonTitles, ...fieldNames.lessonLink[providerCode]}",
                                        settingKey="calendar_lesson_description_student"
                                    )
                                el-form-item
                                    custom-field-format(
                                        v-model="form.calendar_lesson_location_student",
                                        fieldLabel="Event location",
                                        :fieldNames="{...fieldNames.lessonTitles, ...fieldNames.lessonLink[providerCode]}",
                                        settingKey="calendar_lesson_location_student"
                                    )
                        
                    .settings__row
                        .settings__left
                            h2.mt-3 Sync staff calendars 
                            p Manage syncing staff timetables into calendars.
                        .settings__right
                            employee-rules.box-card.settings__pad-bottom(v-model="employee_calendar_rule_object", :rules_type="`calendar`")
                    .settings__row
                        .settings__left
                            h2.mt-3 Staff lesson sync
                        .settings__right
                            el-card.box-card.settings__pad-bottom
                                el-form-item(label="Maximum number of weeks to sync")
                                    el-select(v-model="form.calendar_lesson_weeks_employee")
                                        el-option(v-for="(item,i) in [0,1,2,3,4]" :key="i" :label="item" :value="item" )
                                el-form-item
                                    custom-field-format(
                                        v-model="form.calendar_lesson_title_employee",
                                        fieldLabel="Event title",
                                        :fieldNames="{...fieldNames.lessonTitles}",
                                        settingKey="calendar_lesson_title_employee"
                                    )
                                el-form-item
                                    custom-field-format(
                                        v-model="form.calendar_lesson_description_employee",
                                        fieldLabel="Event description",
                                        :fieldNames="{...fieldNames.lessonTitles, ...fieldNames.lessonLink[providerCode]}",
                                        settingKey="calendar_lesson_description_employee"
                                    )
                                el-form-item
                                    custom-field-format(
                                        v-model="form.calendar_lesson_location_employee",
                                        fieldLabel="Event location",
                                        :fieldNames="{...fieldNames.lessonTitles, ...fieldNames.lessonLink[providerCode]}",
                                        settingKey="calendar_lesson_location_employee"
                                    )
                    
        slot(name="footer")
</template>
<script>
import gql from "graphql-tag";
import _ from "lodash";
import moment from "moment";
import StudentRules from "./../includes/StudentRules";
import EmployeeRules from "./../includes/EmployeeRules.vue";
import CustomFieldFormat from "./../includes/CustomFieldFormat.vue"

export default {
    components: {
        StudentRules,
        EmployeeRules,
        CustomFieldFormat
    },
    computed: {
    },
    apollo: {
        form: {
            query: gql`
                {
                    Settings {
                        id
                        student_calendar_active
                        student_calendar_rules {
                            group
                            operator
                            value
                        }
                        student_calendar_rule_match
                        employee_calendar_active
                        employee_calendar_rules {
                            group
                            operator
                            value
                        }
                        employee_calendar_rule_match
                        calendar_lesson_weeks_employee
                        calendar_lesson_title_employee
                        calendar_lesson_description_employee
                        calendar_lesson_location_employee
                        calendar_lesson_notification_active_employee
                        calendar_lesson_notification_minutes_employee
                        calendar_lesson_weeks_student
                        calendar_lesson_title_student
                        calendar_lesson_description_student
                        calendar_lesson_location_student
                        calendar_lesson_notification_active_student
                        calendar_lesson_notification_minutes_student
                        rolling_calendar_enabled
                        rolling_calendar_sync_day
                    }
                }
            `,
            fetchPolicy: "no-cache",
            update(r) {
                let settings = _.cloneDeep(r.Settings);

                this.student_calendar_rule_object.rules = _.cloneDeep(settings.student_calendar_rule_object);
				this.student_calendar_rule_object.active = _.cloneDeep(settings.student_calendar_active);
				delete settings.student_calendar_rules;
				delete settings.student_calendar_rule_match;
				delete settings.student_calendar_active;
                this.employee_calendar_rule_object.rules = _.cloneDeep(settings.employee_calendar_rule_object);
				this.employee_calendar_rule_object.active = _.cloneDeep(settings.employee_calendar_active);
				delete settings.employee_calendar_rules;
				delete settings.employee_calendar_rule_match;
				delete settings.employee_calendar_active;

                return settings;
            },
        },
    },
    data() {
        return {
            form: [],
            employee_calendar_rule_object: {},
            student_calendar_rule_object: {},
            fieldNames: {
                lessonTitles: {
                    "class-name": {
                        label: "Class name",
                        value: "class_name"
                    },
                    "class-code": {
                        label: "Class code",
                        value: "class_code"
                    },
                    "class-description": {
                        label: "Class description",
                        value: "class_description"
                    },
                    "subject-name": {
                        label: "Subject name",
                        value: "subject_name"
                    },
                    "subject-code": {
                        label: "Subject code",
                        value: "subject_code"
                    },
                    "class-academic-year": {
                        label: "Class academic year",
                        value: "class_academic_year"
                    },
                    "room-name": {
                        label: "Room name",
                        value: "room_name"
                    },
                    "room-code": {
                        label: "Room code",
                        value: "room_code"
                    },
                },
                lessonLink: {
                    gapps: {
                        "classroom": {
                            label: "Google classroom",
                            value: "classroom"
                        },
                    },
                    msft: {
                        "teams": {
                            label: "Teams link",
                            value: "teams"
                        },
                    }

                },
                eventTitles: {
                    "event-description": {
                        label: "Event description",
                        value: "event_description"
                    },
                    "event-type": {
                        label: "Event type",
                        value: "event_type"
                    },
                },
            },
            weekdays: moment.weekdays()
        }
    },
    methods: {
        async save() {
            let insert = _.pickBy(this.form, (value, key) => {
				return key !== "__typename" && key !== "id";
			});

            insert.student_calendar_rules = _.map(this.student_calendar_rule_object.rules, (rule) => _.pickBy(rule, (value, key) => key !== "__typename"));
			insert.student_calendar_active = this.student_calendar_rule_object.active;
			insert.student_calendar_rule_match = this.student_calendar_rule_object.match;
            insert.employee_calendar_rules = _.map(this.employee_calendar_rule_object.rules, (rule) => _.pickBy(rule, (value, key) => key !== "__typename"));
			insert.employee_calendar_active = this.employee_calendar_rule_object.active;
			insert.employee_calendar_rule_match = this.employee_calendar_rule_object.match;

			this.$apollo
				.mutate({
					mutation: gql`
						mutation SaveSettings($object: SettingsInput!, $type: SettingsTypeEnum) {
							SaveSettings(object: $object, type: $type) {
								student_calendar_active
                                student_calendar_rules {
                                    group
                                    operator
                                    value
                                }
                                student_calendar_rule_match
                                employee_calendar_active
                                employee_calendar_rules {
                                    group
                                    operator
                                    value
                                }
                                employee_calendar_rule_match
                                calendar_lesson_weeks_employee
                                calendar_lesson_title_employee
                                calendar_lesson_description_employee
                                calendar_lesson_location_employee
                                calendar_lesson_notification_active_employee
                                calendar_lesson_notification_minutes_employee
                                calendar_lesson_weeks_student
                                calendar_lesson_title_student
                                calendar_lesson_description_student
                                calendar_lesson_location_student
                                calendar_lesson_notification_active_student
                                calendar_lesson_notification_minutes_student
							}
						}
					`,
					variables: {
						object: insert,
						type: this.type ? this.type : "school"
					},
				})
				.then((r) => {
					this.loading = false;
					this.$emit("Saved");
					this.$message.success("Settings saved");
				})
				.catch((e) => {
					this.loading = false;
					this.$message.error("Failed to update settings");
				});
		},
    }
};
</script>
